import { Collection } from "dexie";
import { db } from "configs";
import { Fragments } from "requests";
import { decryptAES, encryptAES, encryptSHA256 } from "../encryption";

export const saveUser = (data: Fragments.ApplicationSettingsUser) => {
  db.user
    .where("id")
    .equals(data._id)
    .first()
    .then((user: Collection) => {
      if (user) {
        db.user.update(data._id, {
          id: data._id,
          data: encryptAES(data, data.pin as string),
          pin: data.pin
        });

        return;
      }
      db.user.add({
        id: data._id,
        data: encryptAES(data, data.pin as string),
        pin: data.pin
      });
    })
    .catch(() => {});
};

export const loadUser = async (
  pin: string
): Promise<Fragments.ApplicationSettingsUser | null> => {
  const pinHash = encryptSHA256(pin);
  return db.user
    .where("pin")
    .equals(pinHash)
    .first()
    .then((user: { data: string }) => decryptAES(user.data, pinHash));
};

export const deleteUser = (id: number) => {
  db.user
    .where("id")
    .equals(id)
    .delete()
    .catch(() => {});
};
